"use strict";

exports.__esModule = true;
var styles = {
  right: {
    display: "flex",
    gap: ".3rem",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center"
  },
  left: {
    display: "flex",
    gap: ".3rem",
    flexDirection: "row-reverse",
    justifyContent: "flex-end",
    alignItems: "center"
  },
  bottom: {
    display: "grid",
    gap: ".3rem",
    justifyContent: "start",
    justifyItems: "center"
  }
};
exports["default"] = styles;